<div class="tablehead" [ngClass]="{'contractor': forContractor, 'compact' : compact}">


  <div *ngIf="forContractor && filtered" style="max-width: 1010px; margin-bottom: 40px;" class="alert-info">
    <i class="material-icons ic-info">info</i>
    {{translate.instant('CONTRACTOR_UPLOAD.INFO')}}
  </div>

  <div class="tablefilters" [ngClass]="{'showfilters' : (showfilters) ? 'showfilters' : ''}" *ngIf="filtered">
    <div *ngIf="!forContractor">
      <div class="title">{{translate.instant('DATA.ROOM')}}</div>
      <div class="filter" *ngFor="let room of allRoomTypes;let last = last">
        <a class="filter" [ngClass]="roomSelected(room)" *ngIf="room" id="id_filter_room_{{room}}"
          (click)="updateFilter($event)">
          <img alt="{{room}}" class="logo" src="{{room2imgfn(room)}}" />
          <span>{{room}}</span>
        </a>
      </div>
    </div>

    <div *ngIf="forContractor">
      <div class="title">{{translate.instant('DATA.PID')}}</div>
      <div class="filter" *ngFor="let pid of allPIDs;let last = last">
        <a class="filter" [ngClass]="pidSelected(pid)" *ngIf="pid" id="id_filter_pid_{{pid._id}}"
          (click)="updateFilter($event)">
          <img alt="{{pid.name}}" class="logo" src="../../assets/Nestas-Iconen_sjabloon.png" />
          <span class="pid">{{pid.name}}<br />{{pid.address.city}}</span>
        </a>

      </div>
    </div>

    <br />
    <div class="title">{{translate.instant('DATA.STATUS')}}</div>
    <div class="filter" *ngFor="let status of allStatusTypes;let last = last">
      <a class="filter" [ngClass]="statusSelected(status, last)" *ngIf="status" id="id_filter_status_{{status}}"
        (click)="updateFilter($event)">
        <img alt="{{status}}" class="logo" src="{{status2imgfn(status)}}" />
        <span>{{translate.instant('PID.STATUS.' + (forContractor ? 'CONTRACTOR' : 'OWNER') + '.' + status)}}
          ({{allStatusCount[status]}}) </span>
      </a>
    </div>
  </div>

  <div class="tablewrapper" [ngClass]="{'showfilters' : (showfilters) ? 'showfilters' : ''}">
    <ngx-datatable class="bootstrap" [rows]="allfiles.filtered" [rowHeight]="getHeight()"
      [headerHeight]="getHeaderHeight()" (activate)="onActivate($event)"
      [sorts]="[{prop:'status', dir: 'asc'}, {prop: 'PID.name', dir: 'asc'}]">


      <ngx-datatable-column name="Status" *ngIf="filtered && !compact" [width]="67" [sortable]="true"
        [comparator]="statusComparator" prop="status">

        <ng-template let-row="row" ngx-datatable-cell-template>
          <div [ngStyle]="{'padding-top': selection ? '20px' : '0px'}">
            <img *ngIf="!selection" alt="{{getStatus(row)}}" class="logo" src="{{status2imgfn(getStatus(row))}}"
              style="height:64px;padding:12px;padding-left:4px;padding-right:10px" />

            <mat-checkbox [(ngModel)]="row.checked" [checked]="row.checked" style="margin-left:15px;" *ngIf="selection && !(pid && pid.parentPID && row.sharingType != 'distinct')">
            </mat-checkbox>
          </div>
        </ng-template>

      </ngx-datatable-column>


      <ngx-datatable-column *ngIf="!compact && forContractor" name="{{translate.instant('DATA.PID')}}"
        [width]="getWidth('pid')" [sortable]="true" prop="PID.name" [comparator]="comparator">

        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="divider left-divider">
            <div class="content" style="line-height:1;padding-top:7px">
              <div *ngIf="row.PID">{{row.PID.name}}<br />
                {{row.PID.address && row.PID.address.city}}
              </div>
            </div>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column *ngIf="!compact && forContractor" name="{{translate.instant('DATA.PARENTPID')}}"
        [width]="getWidth('pid')" [sortable]="true" prop="PID.parentPID" [comparator]="comparator">

        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="divider">
            <div class="content" style="line-height:1;padding-top:7px;">
              <div *ngIf="row.PID">{{row.PID.parentPID && row.PID.parentPID.name}}<br />
                {{row.PID.parentPID && row.PID.parentPID.address && row.PID.parentPID.address.city}}
              </div>
            </div>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="{{translate.instant('DATA.NAME')}}" [width]="getWidth('name')" [sortable]="true"
        prop="name" [comparator]="comparator">

        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="divider" [ngStyle]="{'height': (compact) ? '92px' : '64px'}"
            [ngClass]="{'left-divider' : compact || !forContractor}">
            <div class="content" [ngStyle]="{'height': (compact) ? '78px' : '50px'}">
              <!--ellipsis-->
              <div *ngIf="compact" class="compactheader">
                <img alt="{{getStatus(row)}}" class="logo" src="{{status2imgfn(getStatus(row))}}"
                  style="height:16px;" />
                <span>{{row.name}}</span>
              </div>
              <span *ngIf="!compact">{{row.name}}</span>
              <div *ngIf="compact">
                <div *ngIf="forContractor" class="subcontent1L">{{row.PID.name}}
                  {{row.PID.address && row.PID.address.city}}</div>
                <div class="subcontent1L">{{row.type}}</div>
                <div class="subcontent1L">{{row.description}}</div>
                <div *ngIf="!forContractor" class="subcontent1L">{{formatContractor(row)}}
                  {{row.deadline | date: 'dd/MM/yyyy'}}</div>
              </div>
            </div>
          </div>
        </ng-template>
      </ngx-datatable-column>


      <ngx-datatable-column *ngIf="!compact" name="{{translate.instant('DATA.TYPE')}}" [width]="getWidth('type')"
        [sortable]="true" prop="type" [comparator]="comparator">

        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="divider">
            <div class="content ellipsis">{{row.type}}</div>
          </div>
        </ng-template>
      </ngx-datatable-column>


      <ngx-datatable-column *ngIf="!compact" name="{{translate.instant('DATA.DESCRIPTION')}}"
        [width]="getWidth('description')" [sortable]="true" prop="description" [comparator]="comparator">

        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="divider">
            <div style="height: 50px" class="content ellipsis">
              {{row.description}}
            </div>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column *ngIf="!forContractor && !compact" name="{{translate.instant('DATA.ROOM')}}" class="tight"
        [width]="getWidth('room')" [sortable]="true" prop="room" [comparator]="comparator">

        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="divider">
            <div class="content">
              <img style="margin-left:0px; margin-top:10px" *ngIf="row.room" alt="{{row.room}}" class="logo"
                src="{{room2imgfn(row.room)}}" style="height:25px;max-width:25px;" />
            </div>
          </div>
        </ng-template>
      </ngx-datatable-column>


      <!-- <ngx-datatable-column *ngIf="forContractor" name="{{translate.instant('DATA.JOB')}}" class="tight"
        [width]="getWidth('job')" [sortable]="true" prop="job" [comparator]="comparator">

        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="divider">
            <div class="content">
              {{row.job}}
            </div>
          </div>
        </ng-template>
      </ngx-datatable-column>-->

      <ngx-datatable-column *ngIf="!forContractor && !compact" name="{{translate.instant('DATA.CONTRACTOR')}}"
        [width]="140" [sortable]="true" prop="contractor.name" [comparator]="comparator">

        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="divider">
            <div class="content" [ngClass]="contractorClass(row)">
              <div>{{formatContractor(row)}}</div>
            </div>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column *ngIf="!compact" name="{{translate.instant('DATA.DEADLINE_TABLE')}}"
        [width]="getWidth('deadline')" [sortable]="true" prop="deadline" [comparator]="comparator">
        <!-- width 100 -->

        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="divider">
            <div class="content center">
              <div>{{row.deadline | date: 'dd/MM/yyyy'}}</div>
            </div>
          </div>
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </div>
</div>